import Joi from 'joi';

import {constantsRegex} from "../constants/constants.regex";

export const newCustomerValidator = Joi.object({
    last_name: Joi.string().required().messages({
        'string.empty': 'Заповніть це поле',
    }),
    first_name: Joi.string().required().messages({
        'string.empty': 'Заповніть це поле',
    }),
    email: Joi.string().pattern(constantsRegex.EMAIL).required().messages({
        'string.empty': 'Заповніть це поле',
        'string.pattern.base': 'Невалідний email',
    }),
    mobile_nummer: Joi.string().required().messages({
        'string.empty': 'Заповніть це поле',
        'number.base': 'Поле \'mobile_number\' повинно містити тільки цифри',
        'string.pattern.base': 'Невалідний phone',
    }),
    password: Joi.string().required().min(8).messages({
        'string.empty': 'Заповніть це поле',
        'string.min': 'Не менше 8 символів',
    }),
    confirm_password: Joi.string().required().min(8).valid(Joi.ref('password')).messages({
        'string.empty': 'Заповніть це поле',
        'string.min': 'Не менше 8 символів',
        'any.only': 'Паролі не збігаються',
    }),
    comment: Joi.string().allow('')
});
